
import { Building, Home, MapPin, Warehouse, Castle } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface PropertyTypeSelectProps {
  propertyType: string;
  setPropertyType: (value: string) => void;
}

export const PropertyTypeSelect = ({ propertyType, setPropertyType }: PropertyTypeSelectProps) => {
  return (
    <Select value={propertyType} onValueChange={setPropertyType}>
      <SelectTrigger className="w-[180px]">
        <SelectValue placeholder="Property type" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">All Properties</SelectItem>
        <SelectItem value="luxury">
          <span className="flex items-center">
            <Castle className="mr-2 h-4 w-4" />
            Luxury Homes
          </span>
        </SelectItem>
        <SelectItem value="residential">
          <span className="flex items-center">
            <Home className="mr-2 h-4 w-4" />
            Residential
          </span>
        </SelectItem>
        <SelectItem value="commercial">
          <span className="flex items-center">
            <Building className="mr-2 h-4 w-4" />
            Commercial
          </span>
        </SelectItem>
        <SelectItem value="mixed">
          <span className="flex items-center">
            <Warehouse className="mr-2 h-4 w-4" />
            Mixed-Use
          </span>
        </SelectItem>
      </SelectContent>
    </Select>
  );
};
